import React from 'react'
import data from '../Asmaul.json';

const Asmaul = () => {
  return (
    <section
      id='about'
      className='my-[30px] pt-[50px] xl:mt-[100px]'
      data-aos='fade-up'
      data-aos-offset='350'
    >
    <div className='container mx-auto'>
        <div class="overflow-x-auto relative">
        <h2 className='text-secondary flex item-center justify-center text-3xl mb-5'>Asmaul Husna</h2>
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead className="text-xs  uppercase bg-accent-tertiary text-utama">
                    <tr>
                        <th scope="col" className="py-3 px-6">
                            Urutan
                        </th>
                        <th scope="col" className="py-3 px-6">
                            Latin
                        </th>
                        <th scope="col" className="py-3 px-6">
                            Asmaul Husna
                        </th>
                        <th scope="col" className="py-3 px-6">
                            Arti
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => (
                        <tr className="bg-accent-primary border-b dark:border-gray-700">
                            <td className="py-4 px-6">
                                {item.urutan}
                            </td>
                            <th scope="row" className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                {item.latin}
                            </th>
                            <td className="py-4 px-6 font-medium text-2xl text-gray-900 whitespace-nowrap dark:text-white">
                                {item.arab}
                            </td>
                            <td className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                {item.arti}
                            </td>
                        </tr>
                        ))}
                </tbody>
            </table>
        </div>
    </div>
    </section>
  )
}

export default Asmaul;